export default __webpack_public_path__ + "static/military-logo-630029834e564475d759d4cb57518d7b.webp";